export enum TransientAuthType {
    Unknown = 0,
    OrderChangeRequest = 1,
    CcAuth = 2,
    BookingSubdomain = 3,
    BookingSubdomainOrderConfirmation = 4,
    UpdatePaymentInfo = 5,
    ManagedReview = 6,
    AutomaticRetailCheckoutLogin = 7,
    AutomaticReplacement = 9,
    CustomerServiceAgreement = 10,
}

const transientAuthTypeDescription = {
    Unknown: 'Unknown',
    OrderChangeRequest: 'Order Change Request',
    CcAuth: 'Cc Auth',
    BookingSubdomain: 'Booking Subdomain',
    BookingSubdomainOrderConfirmation: 'Booking Subdomain Order Confirmation',
    UpdatePaymentInfo: 'Update Payment Info',
    ManagedReview: 'Managed Review',
    AutomaticRetailCheckoutLogin: 'Automatic Retail Checkout Login',
    AutomaticReplacement: 'Automatic Replacement',
    CustomerServiceAgreement: 'Customer Service Agreement',
};

export const TransientAuthTypeDescription = {
    ...transientAuthTypeDescription,

    get: (value: TransientAuthType | undefined | null): string | undefined => {
        if (typeof (value) === "string") {
            return transientAuthTypeDescription[value];
        }
        if (value===null || value===undefined) {
            return undefined;
        }
        return transientAuthTypeDescription[TransientAuthType[value]  as keyof typeof transientAuthTypeDescription];
    },
    all: [
        { value: 0, label: transientAuthTypeDescription.Unknown },
        { value: 1, label: transientAuthTypeDescription.OrderChangeRequest },
        { value: 2, label: transientAuthTypeDescription.CcAuth },
        { value: 3, label: transientAuthTypeDescription.BookingSubdomain },
        { value: 4, label: transientAuthTypeDescription.BookingSubdomainOrderConfirmation },
        { value: 5, label: transientAuthTypeDescription.UpdatePaymentInfo },
        { value: 6, label: transientAuthTypeDescription.ManagedReview },
        { value: 7, label: transientAuthTypeDescription.AutomaticRetailCheckoutLogin },
        { value: 9, label: transientAuthTypeDescription.AutomaticReplacement },
        { value: 10, label: transientAuthTypeDescription.CustomerServiceAgreement },
    ] as ReadonlyArray<{label: string, value: number}>
};
